const debug = process.env.NODE_ENV === 'development'
const subpath = process.env.PUBLIC_URL

const defaultConfig = {
    debug,
    /** 子路径 */
    subpath,
    /** 请求的根路径 */
    baseUrl: subpath,
    /** 标题 */
    documentTitle: 'SmartMuse Courses | 上海博物馆播客',
    /** 简介 */
    documentDescription: '在上海博物馆的无界限课堂，聆听国内外一流学者关于艺术、历史、考古、博物馆等的真知灼见。',
    /** 七牛云文件存储地址 */
    cdnUrl: 'https://shanghai-museum-old-cdn.svell.net/shm',
    /** jssdk配置路径 */
    jssdkUrl: 'https://shanghai-museum-audio.svell.net/service/wechat/jssdk/signature?url=',
    // 站点根路径
    basePath: window.location.origin + '/shm/courses/',
}

export default defaultConfig